<script>
import { Component, Vue } from 'vue-property-decorator'
/* eslint-disable */
import Header from '@/components/common/Header'
import Login from './login'
/* eslint-disable */

@Component
export default class Index extends Vue {
  render() {
    return (
      <section class="api-wrap">
        <Header
          class={{
            'header-opacity': true,
            'header-black-fadein': this.isHeader
          }}
        >
          <div class="header-nav header-nav-api">
            <div class='by-newrank' />
            <Login />
          </div>
        </Header>
        <div class="api-head">
          <div class="api-head-box">
            <h3 class="api-head-title">新媒体数据API</h3>
            <p class="api-head-desc">海量精准新媒体数据，分析研究好助手</p>
            <div class="api-head-btn">
              <el-button class="api-head-btn-view" onClick={this.viewDoc}>
                查看文档
              </el-button>
              <el-button type="primary" class="api-head-btn-start" onClick={this.startTryOut}>
                开始使用
                <span class="api-head-btn-start--cheap" />
              </el-button>
            </div>
          </div>
          <div class="api-head-tip">
            <div class="api-head-tip-item">
              <span class="api-head-tip-item-algorithm" />
              <span>公正透明的算法支持</span>
            </div>
            <div class="api-head-tip-item">
              <span class="api-head-tip-item-secure" />
              <span>稳定全面的多平台数据</span>
            </div>
            <div class="api-head-tip-item">
              <span class="api-head-tip-item-wepy" />
              <span>支持HTTPS，助力小程序开发</span>
            </div>
            <div class="api-head-tip-item">
              <span class="api-head-tip-item-24hours" />
              <span>7X24小时及时响应</span>
            </div>
          </div>
        </div>
        <div class="api-foot">
          <p class="api-foot-title">使用流程</p>
          <div class="api-platform">
            <span>支持平台</span>
            <span class="api-platform-weixin" />
            <span class="api-platform-weibo" />
            <span class="api-platform-toutiao" />
          </div>
          <div class="api-foot-setp" />
        </div>
      </section>
    )
  }
  isHeader = false
  viewDoc() {
    this.$router.push({ path: '/list' })
  }
  startTryOut() {
    this.$router.push({ path: '/buy' })
  }
}
</script>

<style lang="postcss">
@import '../../assets/css/_pub.css';
.api {
  &-wrap {
    height: 100%;
  }
  &-head {
    height: 50%;
    background: url(~@/assets/img/bg.png) center / cover no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--white);
    text-align: center;
    position: relative;
    &-tip {
      height: 60px;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: rgba(255, 255, 255, 0.2);
      display: flex;
      justify-content: center;
      align-items: strecth;
      &-item {
        border-right: 1px solid rgba(255, 255, 255, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        padding: 0 40px;
        &:first-child {
          border-left: 1px solid rgba(255, 255, 255, 0.3);
        }
        & span:first-child {
          margin-right: 8px;
        }
        &-algorithm {
          @mixin size 22px, 24px;
          background: url(~@/assets/img/algorithm.png) center/cover no-repeat;
        }
        &-24hours {
          @mixin size 20px, 22px;
          background: url(~@/assets/img/24hours.png) center/cover no-repeat;
        }
        &-secure {
          @mixin size 21px, 19px;
          background: url(~@/assets/img/platform.png) center/cover no-repeat;
        }
        &-wepy {
          @mixin size 20px;
          background: url(~@/assets/img/wepy.png) center/cover no-repeat;
        }
      }
    }
    &-title {
      font-size: 40px;
      font-weight: normal;
    }
    &-desc {
      font-size: 16px;
      margin: 10px 0 50px;
    }
    &-btn {
      width: 380px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      &-start,
      &-view {
        @mixin size 150px, 48px;
        padding: 0;
        font-size: 18px;
        &:focus {
          outline: none;
        }
      }
      &-view {
        background-color: transparent !important;
        color: var(--white);
        &:hover {
          color: #26b3eb;
          border-color: #26b3eb;
        }
      }
      &-start {
        background-color: var(--white);
        color: var(--default-color);
        border: 0;
        position: relative;
        &:hover {
          background-image: linear-gradient(to right, #26b3eb, #2edadc) !important;
          color: #fff !important;
          border-color: transparent !important;
        }
        &--cheap {
          position: absolute;
          @mixin size 52px, 47px;
          background: url('~@/assets/img/8.png') center/cover no-repeat;
          top: 0;
          right: 0;
          transform: translate(32px, -35px);
        }
      }
    }
  }
  &-platform {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #999;
    & span:not(:first-child) {
      margin-left: 10px;
    }
    &-weixin {
      @mixin size 19px;
      background: url(~@/assets/img/weixin.png) no-repeat;
    }
    &-weibo {
      @mixin size 21px, 18px;
      background: url(~@/assets/img/weibo.png) no-repeat;
    }
    &-toutiao {
      @mixin size 20px;
      background: url(~@/assets/img/toutiao.png) no-repeat;
    }
  }
  &-foot {
    padding-top: 40px;
    padding-bottom: 37px;
    height: 50%;
    display: flex;
    flex-direction: column;
    &-title {
      text-align: center;
      font-size: 20px;
      margin-bottom: 8px;
    }
    &-setp {
      flex: 1;
      // height: 269px;
      background: url(~@/assets/img/step.png) center/cover no-repeat;
      margin-top: 30px;
    }
  }
}
.header-black-fadein {
  animation: opacity 0.3s linear both;
}
@keyframes opacity {
  0% {
    background-color: rgba(21, 24, 25, 0);
  }
  100% {
    background-color: rgba(21, 24, 25, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/Index.vue